import {schema} from 'normalizr';


export const UserAccountSchema = new schema.Entity('userAccount', {});